export default {
  suppliers: [],
  loading: false,
  total: 0,
  FilteredCount: 0
}
